import styled, { createGlobalStyle, css } from 'styled-components';

interface ILayerBlock {
  isActived: boolean;
}

interface IButton {
  label: string;
}

interface IContent {
  fontTitle: string;
  fontContent: string;
  sizeImage: number;
}

const activedModifers = {
  actived: css`
    #icon-minimize {
      transform: rotate(-180deg);
    }
  `,
};

export const Box = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const GlobalStyles = createGlobalStyle`
${({ theme }) => css`
  .react-resizable {
    width: 100%;
  }
  .react-resizable-handle {
    position: absolute;
    pointer-events: auto;
    width: 20px;
    height: 20px;
    color: ${theme.colors.white};
  }
  .react-resizable-handle-se {
    bottom: 5px;
    right: 4px;
    cursor: se-resize;
  }

  .react-draggable {
    pointer-events: none;
  }
`}
`;

export const ResizableContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
`;

export const LayerBlock = styled.div<ILayerBlock>`
  ${({ theme, isActived }) => css`
    width: 100%;
    flex: 0 0 auto;
    pointer-events: auto;
    padding: ${theme.spacings[6]} ${theme.spacings[8]};
    display: flex;
    align-items: center;
    border-top-right-radius: ${theme.radius.xs};
    border-top-left-radius: ${theme.radius.xs};
    background-color: ${theme.colors.blue600};
    color: ${theme.colors.white};
    font-size: ${theme.font.sizes.md};
    cursor: grab;
    ${!isActived && `border: 3px solid ${theme.colors.blueGray900};`}

    @media (max-width: 600px) {
      font-size: ${theme.font.sizes.sm};
    }

    @media (max-width: 400px) {
      font-size: ${theme.font.sizes.sm};
    }

    svg {
      width: ${theme.font.sizes.xl};
      transition: all 0.2s;
    }

    #btn-subtitle {
      transform: rotate(-360deg);
      margin-right: ${theme.spacings[6]};
      cursor: auto;
    }

    #btn-dragglable {
      margin-left: auto;
    }

    #btn-subtitle,
    #btn-dragglable,
    #title-dragglable {
      cursor: grab;
    }

    p {
      margin-bottom: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    ${!isActived && activedModifers.actived}

    ${!isActived && 'border-radius: ' + theme.radius.xs}
  `}
`;

export const Footer = styled.div`
  ${({ theme }) => css`
    height: 29px;
    width: 100%;
    flex: 0 0 auto;
    padding: ${theme.spacings[6]} ${theme.spacings[8]};
    display: flex;
    align-items: center;
    border-bottom-right-radius: ${theme.radius.xs};
    border-bottom-left-radius: ${theme.radius.xs};
    background-color: ${theme.colors.blue600};
    color: ${theme.colors.white};
    cursor: grab;
    pointer-events: auto;

    .counter {
      margin-left: 5px;
      font-size: ${theme.font.sizes.xs};
      font-family: ${theme.font.family.default};
    }
  `}
`;

export const Content = styled.div<IContent>`
  ${({ theme, fontTitle, fontContent, sizeImage }) => css`
    width: 100%;
    flex: 1 1 auto;
    min-height: 0;
    box-sizing: border-box;
    background-color: ${theme.colors.white};
    padding: 10px;
    display: grid;
    grid-auto-rows: min-content;
    font-size: ${fontContent};
    pointer-events: auto;

    img {
      pointer-events: none;
      max-width: 100%;
    }

    .customSubtitles {
      max-width: 70% !important;
    }

    p {
      color: ${theme.colors.gray900};
      font-family: sans-serif;
    }

    a {
      color: #1e90ff;
    }

    h4 {
      font-size: ${fontTitle};
    }

    img {
      transform: scale(${sizeImage});
      transform-origin: top left;
    }

    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 3px;
    }

    &::-webkit-scrollbar-track {
      background: ${theme.colors.gray50};
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${theme.colors.blue700};
    }

    .zoom {
      position: absolute;
      right: 8px;
      bottom: 35px;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: ${theme.font.sizes.sm};
    }

    .zoomButton {
      background-color: ${theme.colors.blue600};
      color: ${theme.colors.white};
      width: 20px;
      height: 20px;
      border-radius: 5px;
      margin: 2px 0;
    }
  `}
`;

export const Button = styled.button<IButton>`
  ${({ theme, label }) => css`
    position: relative;
    display: inline-flex;
    justify-content: center;
    border: 0;
    background-color: transparent;
    color: #fff;

    & + button {
      margin-left: ${theme.spacings[6]};
    }

    &:hover {
      &::before {
        opacity: 1;
      }
    }

    &::before {
      content: '${label}';
      padding: ${theme.spacings[6]};
      position: absolute;
      top: -3rem;

      font-family: ${theme.font.family.default};
      font-size: ${theme.font.sizes.xs};
      font-weight: ${theme.font.weights.bold};

      border: 1px solid ${theme.colors.white};
      border-radius: 0.4rem;

      background-color: ${theme.colors.black};
      color: ${theme.colors.white};

      opacity: 0;
      transition: all 0.2s;
      pointer-events: none;
    }
  `}
`;

export const ContentWrapper = styled.div<{ isActived: boolean }>`
  ${({ isActived }) => css`
    transition: all 0.3s ease;
    display: ${isActived ? 'flex' : 'none'};
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
  `}
`;
